<div class="row">
    <i *ngIf="_isLoading" class="fa fa-circle-o-notch fa-spin" style="font-size:38px; color: #337ab7;"></i>
</div>

<p class="alert-warning bold">{{_validationMessage}}</p>

<div *ngIf="isMonograph">
    <div *ngIf="isAdding()" class="form-horizontal">
        <div class="row">
            <edit-prop label="File Label" szs="2,2">
                <input class="form-control" type="text" [(ngModel)]="_data.edmMaterialMonograph.currentEntity.fileLabel">
            </edit-prop>

            <edit-prop label="File Name" szs="2,3">
                <input class="form-control" type="text" [(ngModel)]="_data.edmMaterialMonograph.currentEntity.fileName">
                <span class="italic">This will be generated when a file is chosen, but you can change the file name.</span>
            </edit-prop>

            <label class="fileContainer" class="item-choose-file" style="margin-left: 188px;">
                <input id="fileInputElement" type="file" accept=".pdf, .tif" (change)="onFileInput($any($event.target).files)"/>
            </label>
        </div>
    </div>

    <div *ngIf="isEditing()" class="form-horizontal">
        <div class="row">
            <edit-prop label="File Label" szs="2,2">
                <input class="form-control" type="text" [(ngModel)]="_data.edmMaterialMonograph.currentEntity.fileLabel">
            </edit-prop>

            <edit-prop label="File Name" szs="2,2">
                <input class="form-control" type="text" [(ngModel)]="_data.edmMaterialMonograph.currentEntity.fileName">
            </edit-prop>
        </div>
    </div>

    <div *ngIf="isRemoving()" class="form-horizontal">
        <p class="inline bold" style="background-color: aliceblue; font-size: 14px;">Please confirm you would like this file removed.</p>
        <div class="row">
            <label class="bold col-md-1 publication-title" style="font-size: 14px;">File Label:</label>
            <span>{{_data.editMaterialFileData.fileLabel}}</span>
        </div>
        <div class="row">
            <label class="bold col-md-1 publication-title" style="font-size: 14px;">File Name:</label>
            <span>{{_data.editMaterialFileData.fileName}}</span>
        </div>
    </div>
</div>

